"use client";

import useSelectedPowerOfAttorney from "@portal/hooks/useSelectedPowerOfAttorney";
import useBank from "@portal/hooks/useBank";
import PageSpinner from "@portal/components/molecules/v2/pageSpinner";
import NoAccessToFeature from "../../../noAccessToFeature";
import { IPageEnabledClientWrapperProps } from "./types";

const PageEnabledClientWrapper = ({
  session,
  children,
  requiresStockPageEnabled,
  requiresFundPageEnabled,
}: React.PropsWithChildren<IPageEnabledClientWrapperProps>) => {
  const { isLoading } = useSelectedPowerOfAttorney();
  const { data: bankData, isLoading: bankIsLoading } = useBank();

  if (bankIsLoading || isLoading) return <PageSpinner />;

  return (
    <div className="mb-3">
      {(requiresStockPageEnabled && !bankData?.stockTradingEnabled) ||
      (requiresFundPageEnabled && !bankData?.fundTradingEnabled) ? (
        <NoAccessToFeature session={session} />
      ) : (
        children
      )}
    </div>
  );
};

export default PageEnabledClientWrapper;
